import { Layout } from '@/components/Layout';

export default function Terms() {
  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-12 py-12 max-w-4xl" data-testid="terms-page">
        <h1 className="text-5xl md:text-6xl font-heading font-bold mb-8">TERMS & CONDITIONS</h1>
        <p className="text-sm text-muted-foreground mb-8">Last Updated: February 2026</p>
        
        <div className="space-y-8 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using PrimeStatLab, you accept and agree to be bound by these Terms and Conditions. 
              If you do not agree, please do not use our site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">2. Description of Service</h2>
            <p>
              PrimeStatLab provides sports betting analysis, player prop breakdowns, and educational content. 
              We do not place bets on your behalf or guarantee any outcomes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">3. No Financial Advice</h2>
            <p className="mb-4">
              Our content is for informational and entertainment purposes only. We are NOT licensed financial advisors or gambling consultants. 
              All betting decisions are your sole responsibility.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">4. Age Restriction</h2>
            <p>
              You must be 18 years or older (21+ where required by law) to use our services. Sports betting may be illegal in your jurisdiction. 
              You are responsible for complying with local laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">5. Intellectual Property</h2>
            <p>
              All content on PrimeStatLab (text, graphics, logos, analysis) is our property and protected by copyright. 
              You may not reproduce, distribute, or modify our content without permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">6. Affiliate Disclosure</h2>
            <p>
              We may earn commissions from sportsbook affiliate links. This does not affect our analysis or recommendations. 
              We only promote platforms we trust.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">7. No Guarantees</h2>
            <p>
              We do not guarantee wins, profits, or specific outcomes. Sports betting involves risk, and you may lose money. 
              Past performance does not guarantee future results.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">8. Limitation of Liability</h2>
            <p>
              PrimeStatLab is not liable for any losses incurred from using our analysis or recommendations. 
              You use our services at your own risk.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">9. User Conduct</h2>
            <p className="mb-4">You agree NOT to:</p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Use our site for illegal activities</li>
              <li>Attempt to hack or disrupt our services</li>
              <li>Scrape or copy our content without permission</li>
              <li>Harass or abuse other users or staff</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">10. Termination</h2>
            <p>
              We reserve the right to suspend or terminate access to our services for violating these terms or for any reason at our discretion.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">11. Changes to Terms</h2>
            <p>
              We may modify these Terms at any time. Continued use of our site constitutes acceptance of updated Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">12. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the United States. Disputes will be resolved in accordance with applicable jurisdiction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground mb-4">13. Contact</h2>
            <p>
              For questions about these Terms, contact: <a href="mailto:primestatlab@gmail.com" className="text-primary hover:underline">primestatlab@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}